<template>
  <a-drawer
    :title="title"
    :visible="value"
    @close="handleClose"
    :width="width"
    :headerStyle="headerStyle"
    :bodyStyle="bodyStyle"
  >
    <slot />
    <div class="bottom-box">
      <a-button class="cancelBtn" @click="handleClose">
        Cancel
      </a-button>
      <a-button
        :loading="confirmLoading"
        class="confirmBtn"
        @click="handleConfirm"
        >Confirm</a-button
      >
    </div>
  </a-drawer>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 600,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      headerStyle: {
        padding: '16px 16px 8px 16px',
      },
      bodyStyle: {
        padding: '20px',
      },
    }
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    handleConfirm() {
      this.$emit('handleConfirm')
    },
  },
}
</script>
<style lang="scss" scoped>
.bottom-box {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  // border-top: 1px solid #e9e9e9;
  padding: 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
  display: flex;
  justify-content: right;
  gap: 12px;
}
.btnText {
  /* medium/base */
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  text-align: center;
  border-radius: 4px;
}
.cancelBtn {
  @extend .btnText;
  color: #606266;

  border: 1px solid var(--Color-Border-border-color, #dcdfe6);
  background: var(--Color-Fill-fill-color-blank, #fff);
}
.confirmBtn {
  @extend .btnText;
  color: #ffffff;

  background: #7367f0;
}

::v-deep .ant-drawer-header {
  .ant-drawer-title {
    color: var(--Color-Text-text-color-primary, #303133);
    text-align: center;

    /* medium/large */
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px; /* 144.444% */
  }
}
</style>
